// Gallery
function switchImg(thumb, src) {
  document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
  document.getElementById('rbrMainImage').src = src;
}

// Tallas
function selectTalla(el, group) {
  if (el.classList.contains('disabled')) return;
  document.querySelectorAll('[data-group="' + group + '"] .talla-opt').forEach(o => o.classList.remove('sel'));
  el.classList.add('sel');
}

// Método de pago
function selectPay(el) {
  el.closest('.payment-opts').querySelectorAll('.pay-opt').forEach(p => p.classList.remove('active'));
  el.classList.add('active');
}

// Modal
function openModal() {
  document.getElementById('modal-overlay').style.display = 'block';
  document.body.style.overflow = 'hidden';
  goToStep1();
}
function closeModal() {
  document.getElementById('modal-overlay').style.display = 'none';
  document.body.style.overflow = '';
}
function closeModalOutside(e) {
  if (e.target === document.getElementById('modal-overlay')) closeModal();
}
function goToStep1() {
  document.getElementById('modal-step-1').style.display = 'block';
  document.getElementById('modal-step-2').style.display = 'none';
  document.getElementById('modal-box').scrollTop = 0;
}
function goToStep2() {
  document.getElementById('modal-step-1').style.display = 'none';
  document.getElementById('modal-step-2').style.display = 'block';
  document.getElementById('modal-box').scrollTop = 0;
}

// ESC
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

// Viewer counter
document.querySelector('.watching span').textContent =
  Math.floor(Math.random() * 26 + 65) + ' personas';